import { LoadingViewQueryResult } from "src/base-components/LoadingView";
import { useRuns } from "src/jobs/api/queries";
import { JobRun } from "src/jobs/types";
import { useWorkspaceContext } from "src/router/routerContextHooks";
import { useSimulationJob } from "src/simulations/useSimulationJob";

export const useSimulationRuns = (flowId: string, flowVersionId: string) => {
  const { workspace } = useWorkspaceContext();
  const { simulationJob, isLoading: isSimulationJobLoading } = useSimulationJob(
    flowId,
    workspace.base_url ?? "",
  );

  const noSimulationJob = !isSimulationJobLoading && simulationJob == undefined;

  const {
    data: simulationRuns,
    isLoading,
    isPending,
  } = useRuns(workspace.base_url ?? "", simulationJob?.id ?? "", {
    flow_version_ids: flowVersionId,
  });

  return {
    simulationRuns: noSimulationJob ? [] : simulationRuns?.pages.flat(),
    isLoading,
    isPending,
  };
};

export const useSimulationRun = (
  flowId: string,
  flowVersionId: string,
  simulationId: string,
): LoadingViewQueryResult<JobRun> => {
  const { simulationRuns, isLoading, isPending } = useSimulationRuns(
    flowId,
    flowVersionId,
  );
  const simulationRun = simulationRuns?.find((run) => run.id === simulationId);
  const isError = !isLoading && !isPending && simulationRun === undefined;
  return {
    data: simulationRun,
    isLoading,
    isRefetching: false,
    isError,
    error: isError ? new Error("Simulation not found") : null,
  };
};
